import { motion } from 'framer-motion';

const HeroSection = () => {
  const userAvatars = [
    'https://public.readdy.ai/ai/img_res/0d37d3d8e1d29e3744b8fbffd70b8f13.jpg',
    'https://readdy.ai/api/search-image?query=female%20technology%20professional%20headshot%20portrait%20with%20friendly%20smile%20wearing%20corporate%20clothing%20against%20clean%20background&width=80&height=80&seq=hero-avatar-2&orientation=squarish',
    'https://readdy.ai/api/search-image?query=male%20IT%20specialist%20portrait%20headshot%20with%20glasses%20wearing%20professional%20attire%20against%20simple%20background&width=80&height=80&seq=hero-avatar-3&orientation=squarish',
    'https://readdy.ai/api/search-image?query=young%20tech%20professional%20headshot%20portrait%20with%20modern%20look%20wearing%20business%20casual%20against%20minimal%20background&width=80&height=80&seq=hero-avatar-4&orientation=squarish',
    'https://readdy.ai/api/search-image?query=senior%20IT%20director%20portrait%20headshot%20with%20professional%20demeanor%20wearing%20formal%20business%20attire%20against%20neutral%20background&width=80&height=80&seq=hero-avatar-5&orientation=squarish'
  ];

  return (
    <section className="relative pt-32 pb-20 px-6 overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-blue-50/30 via-orange-50/20 to-transparent"></div>
      
      <div className="max-w-7xl mx-auto relative z-10">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            className="space-y-8"
          >
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.2 }}
              className="inline-flex items-center space-x-2 bg-orange-100 text-orange-700 px-4 py-2 rounded-full text-sm font-medium"
            >
              <i className="ri-rocket-line text-lg"></i>
              <span>ManageEngine ServiceDesk Plus Entegrasyonu</span>
            </motion.div>

            <div className="space-y-4">
              <h1 className="text-6xl font-extrabold leading-tight" style={{ fontFamily: 'Poppins, sans-serif' }}>
                <span className="text-gray-800">IT Envanter Yönetiminde</span>
                <br />
                <span className="text-[#1A2B4A]">Dijital Devrim:</span>
                <br />
                <span className="bg-gradient-to-r from-[#FF6B35] to-[#FF8C42] bg-clip-text text-transparent">
                  Zimmetle.com
                </span>
              </h1>

              <p className="text-xl text-gray-600 leading-relaxed max-w-xl">
                Islak imza karmaşasına son verin. ManageEngine ServiceDesk Plus ile tam entegre, kullanıcı onaylı ve özelleştirilebilir dijital zimmet yönetim sistemi.
              </p>
            </div>

            <div className="flex flex-wrap gap-4">
              <button 
                onClick={() => {
                  const element = document.getElementById('contact');
                  if (element) {
                    element.scrollIntoView({ behavior: 'smooth' });
                  }
                }}
                className="px-8 py-4 bg-[#FF6B35] text-white rounded-lg font-semibold text-lg hover:bg-[#FF5722] transition-all shadow-xl hover:shadow-2xl hover:scale-105 flex items-center space-x-2 cursor-pointer whitespace-nowrap"
              >
                <span>Ücretsiz Demoyu Başlat</span>
                <i className="ri-arrow-right-line text-xl"></i>
              </button>
              <button className="px-8 py-4 border-2 border-[#1A2B4A] text-[#1A2B4A] rounded-lg font-semibold text-lg hover:bg-[#1A2B4A] hover:text-white transition-all flex items-center space-x-2 cursor-pointer whitespace-nowrap">
                <i className="ri-play-circle-line text-xl"></i>
                <span>Nasıl Çalışır?</span>
              </button>
            </div>

            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.6 }}
              className="flex items-center space-x-4 pt-4"
            >
              <div className="flex -space-x-3">
                {userAvatars.map((avatar, index) => (
                  <div key={index} className="w-12 h-12 rounded-full border-4 border-white overflow-hidden shadow-lg">
                    <img src={avatar} alt={`User ${index + 1}`} className="w-full h-full object-cover object-top" />
                  </div>
                ))}
              </div>
              <p className="text-gray-600 font-medium">
                <strong className="text-[#1A2B4A]">5+</strong> IT profesyoneli tarafından güvenle kullanılıyor
              </p>
            </motion.div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.3 }}
            className="relative"
          >
            <div className="relative transform rotate-3 hover:rotate-0 transition-transform duration-500">
              <div className="absolute inset-0 bg-gradient-to-br from-[#FF6B35]/20 to-[#1A2B4A]/20 blur-3xl"></div>
              <div className="relative w-full h-[600px]">
                <img 
                  src="https://public.readdy.ai/ai/img_res/84718b4a-8361-4f6c-beeb-cc5e4f4725f2.jpg"
                  alt="Digital Inventory Management"
                  className="w-full h-full object-contain object-top drop-shadow-2xl"
                />
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
